import React, { useState } from 'react'
import './LeaveType.css'
import { Col, Radio, Row, Switch } from 'antd'
function LeaveType() {
    const [value, setValue] = useState(1);
  const onChange = (e) => {
    console.log('radio checked', e.target.value);
    setValue(e.target.value);
  };
    return (
        <div>
            <p className='leavetype-add'>+Add More Leaves</p>
            <Row>
                <Col>
                    <div className='leave-back flex justify-between'>
                        <p className='casual-leave-type'>Casual Leave</p>
                        <Switch size="small" defaultChecked />
                    </div>
                    <Radio.Group onChange={onChange} value={value} className='flex'>
                        <Radio size="small" value={1} className='paid'>Paid</Radio>
                        <Radio value={2} className='paid'>Unpaid</Radio>
                    </Radio.Group>
                </Col>
                <Col>
                <div className='leave-back flex justify-between ml-2'>
                        <p className='casual-leave-type'>Sick Leave</p>
                        <Switch size="small" defaultChecked />
                    </div>
                    <Radio.Group onChange={onChange} value={value} className='flex ml-2'>
                        <Radio size="small" value={1} className='paid'>Paid</Radio>
                        <Radio value={2} className='paid'>Unpaid</Radio>
                    </Radio.Group>
                </Col>
                <Col>
                <div className='leave-back flex justify-between ml-2'>
                        <p className='casual-leave-type mr-1'>Compensatory Leave</p>
                        <Switch size="small" defaultChecked />
                    </div>
                    <Radio.Group onChange={onChange} value={value} className='flex ml-2'>
                        <Radio size="small" value={1} className='paid'>Paid</Radio>
                        <Radio value={2} className='paid'>Unpaid</Radio>
                    </Radio.Group>
                </Col>
                <Col>
                <div className='leave-back flex justify-between ml-2'>
                        <p className='casual-leave-type'>Lorem Leave</p>
                        <Switch size="small" defaultChecked />
                    </div>
                    <Radio.Group onChange={onChange} value={value} className='flex ml-2'>
                        <Radio size="small" value={1} className='paid'>Paid</Radio>
                        <Radio value={2} className='paid'>Unpaid</Radio>
                    </Radio.Group>
                </Col>
            </Row>
        </div>
    )
}

export default LeaveType